function initProductTable() {

  const tables = document.querySelectorAll("#productTable");
  if (!tables.length) return;

  tables.forEach(table => {

    const tableBody = table.querySelector("tbody");
    if (!tableBody) return;

    let rows = Array.from(tableBody.querySelectorAll(".product-row"));
    if (!rows.length) return;

    function extractDimensions(row) {

      let raw = row.dataset.size || "";

      raw = raw
        .replace(/"/g, "")
        .replace(/ft/gi, "")
        .replace(/\s+/g, " ")
        .trim();

      if (!raw) return [0];

      const parts = raw.split(/\s*[xX]\s*/);

      return parts.map(part => {

        part = part.trim();

        const mixed = part.match(/^(\d+)\s+(\d+)\/(\d+)/);
        if (mixed) {
          return parseFloat(mixed[1]) + (mixed[2] / mixed[3]);
        }

        const fraction = part.match(/^(\d+)\/(\d+)/);
        if (fraction) {
          return fraction[1] / fraction[2];
        }

        return parseFloat(part) || 0;

      });
    }

    rows.sort((a, b) => {

      const dimsA = extractDimensions(a);
      const dimsB = extractDimensions(b);

      const max = Math.max(dimsA.length, dimsB.length);

      for (let i = 0; i < max; i++) {

        const valA = dimsA[i] ?? 0;
        const valB = dimsB[i] ?? 0;

        if (valA !== valB) {
          return valA - valB;
        }

      }

      return 0;

    });

    rows.forEach(r => tableBody.appendChild(r));


    const quantityInputs = table.querySelectorAll(".quantity-input");

    quantityInputs.forEach(input => {

      const minusBtn = input.querySelector(".quantity-input-minus");
      const plusBtn = input.querySelector(".quantity-input-plus");
      const numberInput = input.querySelector("input[type='number']");

      if (!minusBtn || !plusBtn || !numberInput) return;

      const formId = numberInput.getAttribute("form");
      const formQuantityInput = document.getElementById(
        `form-quantity-${formId?.split("-")[2]}`
      );

      minusBtn.addEventListener("click", () => {

        const val = parseInt(numberInput.value) || 1;

        if (val > 1) {
          numberInput.value = val - 1;
          if (formQuantityInput) formQuantityInput.value = val - 1;
        }

      });

      plusBtn.addEventListener("click", () => {

        const val = parseInt(numberInput.value) || 1;
        numberInput.value = val + 1;

        if (formQuantityInput) formQuantityInput.value = val + 1;

      });

      numberInput.addEventListener("change", () => {

        if (numberInput.value < 1) numberInput.value = 1;
        if (formQuantityInput) formQuantityInput.value = numberInput.value;

      });

    });

  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductTable);
} else {
  initProductTable();
}

document.addEventListener('shopify:section:load', initProductTable);





document.addEventListener('shopify:section:load', initProductTable);



//mini cart drawer open when Add to cart
document.addEventListener('submit', function(event) {

  const form = event.target;

  if (!form.matches('form[action="/cart/add"]')) return;

  event.preventDefault();

  const submitBtn = form.querySelector('[type="submit"]');
  submitBtn.disabled = true;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(() => {

    const miniCart = document.querySelector('mini-cart');

    if (miniCart) {
      miniCart.updateSectionContents();
      miniCart.open();
    }

  })
  .catch(error => {
    console.error('Add to cart error:', error);
  })
  .finally(() => {
    submitBtn.disabled = false;
  });

});